import React from 'react';
import OnboardingLayout from './OnboardingLayout';
import OnboardingStep1 from './step1';

export default class OnboardingStep1Page extends React.Component {
    render() {
        return (
            <OnboardingLayout currentStep={1} totalSteps={5}>
                <OnboardingStep1 />
            </OnboardingLayout>
        );
    }
}
